{
  "meta": {
    "actual": "Import dépenses réelles",
    "planned": "Import dépenses prévues"
  },
  "import": "Import dépenses {packageType}",
  "advantages": "Avantages",
  "types": {
    "actual": "réelles",
    "planned": "prévues",
    "crm": "crm",
    "specific": "spécifiques"
  },
  "import_types": {
    "MANUAL": "Import manuel",
    "CRM": "Import crm",
    "SPECIFIC": "Import de dépenses spécifiques"
  },
  "history": {
    "actual": "dépenses réelles",
    "planned": "dépenses prévues",
    "specific": "dépenses réelles spécifiques"
  },
  "toast": {
    "pending": "Import {expenseType} est en cours.",
    "done": "Import {expenseType} terminé avec succès.",
    "failed": "Import {expenseType} terminé en échec.",
    "actual": "dépenses réelles",
    "planned": "dépenses prévues",
    "crm": "dépenses CRM",
    "specific": "dépenses spécifiques",
    "generation_failed": "Désolé, quelque chose s'est mal passé. Veuillez réessayer plus tard."
  },
  "tabulations": {
    "generate": {
      "cta_label": "Générer le template",
      "no_generated_template": "Aucun fichier généré",
      "generated_at": "Généré le {date}",
      "generation_loading": "Template en cours de génération",
      "tab_title": "Générer/Téléverser un import",
      "template": {
        "title": "Générer un template",
        "information": "Veuillez générer/télécharger le template avant de pouvoir téléverser un import de dépenses {packageType}"
      },
      "select_import_type": {
        "title": "Type d'import",
        "information": "Veuillez sélectionner le type d'import de dépenses prévues.",
        "advantages_types": {
          "ALL": "Tous"
        }
      },
      "upload": {
        "modal": {
          "title": "Téléverser un import spécifique",
          "text": "L’import des dépenses réelles supprime uniquement les dépenses déjà issues d’un import."
        },
        "title": "Téléverser un import",
        "information": "Veuillez patienter jusqu'à la fin du chargement après avoir téléversé un import de dépenses {packageType}",
        "input_title": "Veuillez téléverser un import de dépenses {packageType}",
        "format": {
          "authorized": "Format autorisé: XLSX",
          "accepted": "Fichier accepté: template du ticket"
        },
        "cta_label": "Sélectionner un fichier",
        "cta_import": "Téléverser votre import"
      }
    },
    "history": {
      "list_title": "Template importés",
      "tab_title": "Historique de l'import",
      "column": {
        "state": "État",
        "type": "Type",
        "created_at": "Importé le",
        "action": "Action"
      },
      "status": {
        "PENDING": "EN COURS",
        "FAILED": "ÉCHEC",
        "DONE": "SUCCÈS"
      },
      "type": {
        "MANUAL": "Manuel",
        "CRM": "CRM",
        "SPECIFIC": "Réelles spécifiques"
      }
    }
  }
}
